import { Observable, ReplaySubject, filter, take } from 'rxjs';
export abstract class StateService<T> {
    protected subject = new ReplaySubject<T>();
    protected staticSubject = new ReplaySubject<T>(1);
    public abstract get(id: any): Observable<T>;
    public getState(): Observable<T> {
        return this.subject.asObservable();
    }

    public getStaticState(filterFn: (obj: T) => boolean = Boolean): Observable<T> {
        return this.staticSubject.asObservable().pipe(filter(filterFn));
    }

    public setState(state: T): void {
        this.subject.next(state);
        this.staticSubject.next(state);
    }
    public populateState(id: any): void {
        this.get(id)
            .pipe(take(1))
            .subscribe((result) => this.setState(result));
    }
    public clearState() {
        this.subject.complete();
        this.subject = new ReplaySubject<T>();
        this.staticSubject.next(null);
    }
}
